import React from 'react';

import Fade from 'react-reveal/Fade';

import {
	ContactPageContainer,
	ContactsHeader,
	ContactsParagraph,
	EmailLinkButtonContainer,
	EmailLinkButton
} from './contact.styles';

const ContactPage = () => (
	<ContactPageContainer>
		<Fade bottom cascade>
			<ContactsHeader>Contact Me</ContactsHeader>
			<ContactsParagraph>contact@trevormarlowe.com</ContactsParagraph>
			<EmailLinkButtonContainer>
				<a href='mailto:contact@trevormarlowe.com'>
					<EmailLinkButton>Email</EmailLinkButton>
				</a>
			</EmailLinkButtonContainer>
		</Fade>
	</ContactPageContainer>
);

export default ContactPage;
